/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
module.exports = Number.isInteger || function _isInteger(n) {
  return (n << 0) === n;
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isInteger.js
// module id = 467
// module chunks = 0